export const ALLERGENS = [
  {
    id: "milk",
    name: "Milk (Dairy)",
    triggers: [
      "casein",
      "caseinate",
      "ammonium caseinate",
      "calcium caseinate",
      "magnesium caseinate",
      "potassium caseinate",
      "sodium caseinate",
      "whey",
      "whey concentrate",
      "whey isolate",
      "whey hydrolysate",
      "lactalbumin",
      "lactoglobulin",
      "lactose",
      "recaldent",
      "tagatose",
      "rennet casein"
    ],
    commonFoods: ["Butter", "Buttermilk", "Cheese", "Cream", "Curds", "Custard", "Ghee", "Half-and-Half", "Kefir", "Koumiss", "Paneer", "Pudding", "Sour Cream", "Yogurt"],
    hiddenSources: [
      "Deli meats (shared slicers with cheese)",
      "Canned tuna (casein)",
      "Potato chips (flavor powders)",
      "Chewing gum (Recaldent)",
      "Steak (finished with butter)",
      "\"Non-dairy\" creamers (caseinates)",
      "Breath mints"
    ],
    crossContact: "Shared pans, griddles, slicers, and steam wands.",
  },
  {
    id: "egg",
    name: "Egg",
    triggers: ["albumin", "globulin", "livetin", "lysozyme", "ovalbumin", "ovovitellin", "surimi", "vitellin"],
    commonFoods: ["Mayonnaise", "Meringue", "Eggnog", "Hollandaise", "Custard"],
    hiddenSources: [
      "Shiny glaze on pretzels/bagels (egg wash)",
      "Foam toppings on coffee/cocktails",
      "Fresh pasta",
      "Meatballs (binder)",
      "Root beer (foaming agent in old recipes)",
      "Fried rice"
    ],
    crossContact: "Bakeries and shared fryers with batter.",
  },
  {
    id: "peanut",
    name: "Peanut",
    triggers: ["arachis oil", "peanut oil", "goober", "groundnut", "mandelonas", "valomilk"],
    commonFoods: ["Peanut butter", "Mixed nuts", "Peanut flour"],
    hiddenSources: ["Chili (thickener)", "Mole sauce", "Egg rolls (edge seal)", "Glazes/Marinades", "Pet food", "Bird seed", "African stews"],
    crossContact: "Shared candy lines, bakeries, ice cream counters.",
  },
  {
    id: "tree_nut",
    name: "Tree Nuts",
    subTypes: [
      "Almond",
      "Black walnut",
      "Brazil nut",
      "California walnut",
      "Cashew",
      "Filbert (Hazelnut)",
      "Heartnut (Japanese walnut)",
      "Macadamia nut (Bush nut)",
      "Pecan",
      "Pine nut (Pinon nut)",
      "Pistachio",
      "Walnut (English, Persian)"
    ],
    relatedFoodsNotFdaMajorTreeNuts: [
      "Beech nut",
      "Butternut",
      "Chestnut",
      "Chinquapin",
      "Coconut",
      "Cola nut (Kola nut)",
      "Ginkgo nut",
      "Hickory nut",
      "Lychee nut",
      "Palm nut",
      "Pili nut",
      "Shea nut"
    ],
    triggers: ["gianduja", "marzipan", "frangelico", "amaretto", "nutella"],
    commonFoods: ["Desserts", "Nut butters", "Trail mixes"],
    hiddenSources: [
      "Mortadella (pistachio)",
      "Pesto (pine nuts/walnuts)",
      "BBQ sauce (pecan/walnut)",
      "Artificial almond extract",
      "Bean bags/Hackysacks (crushed shells)"
    ],
    crossContact: "Bakeries, ice cream, and shared chocolate equipment.",
  },
  {
    id: "soy",
    name: "Soy",
    triggers: [
      "edamame",
      "miso",
      "natto",
      "shoyu",
      "tamari",
      "tempeh",
      "tofu",
      "tvp",
      "textured vegetable protein",
      "hvp",
      "hydrolyzed vegetable protein",
      "mono- and diglycerides",
      "lecithin",
      "lecithin (soy)",
      "glycine max"
    ],
    commonFoods: ["Tofu", "Soy sauce", "Tempeh", "Edamame", "Miso soups"],
    hiddenSources: [
      "Canned tuna (vegetable broth)",
      "Vitamin E supplements",
      "Cooking sprays",
      "Chocolate (lecithin)",
      "Processed meats (fillers)",
      "Infant formula"
    ],
    crossContact: "Shared woks and fryers with soy marinades.",
  },
  {
    id: "wheat",
    name: "Wheat & Gluten",
    triggers: [
      "bulgur",
      "couscous",
      "durum",
      "einkorn",
      "emmer",
      "farina",
      "farro",
      "graham",
      "kamut",
      "matzoh",
      "seitan",
      "semolina",
      "spelt",
      "triticale",
      "vital gluten",
      "triticum"
    ],
    commonFoods: ["Bread", "Pasta", "Crackers", "Cakes", "Cookies"],
    hiddenSources: [
      "Soy sauce (fermented with wheat)",
      "Surimi (imitation crab)",
      "Ale/Beer",
      "Licorice",
      "Play-Doh",
      "Salad dressings",
      "Roux/soup thickeners",
      "Communion wafers"
    ],
    crossContact: "Shared fryers and bakery equipment with flour dust.",
  },
  {
    id: "fish",
    name: "Fish (Finned)",
    triggers: ["surimi", "roe", "caviar", "isinglass", "fish gelatin"],
    commonFoods: ["Fish fillets", "Fish sticks", "Sushi"],
    hiddenSources: [
      "Worcestershire sauce (anchovies)",
      "Caesar dressing (anchovies)",
      "Caponata",
      "BBQ sauce (anchovy base)",
      "Asian dipping sauces (Nam Pla)",
      "Shared oil with fish"
    ],
    crossContact: "Shared fryers and grills for fish.",
  },
  {
    id: "shellfish",
    name: "Shellfish",
    subTypes: [
      "Barnacle",
      "Crab",
      "Crawfish",
      "Krill",
      "Lobster",
      "Prawn",
      "Shrimp",
      "Abalone",
      "Clam",
      "Mussel",
      "Oyster",
      "Scallop",
      "Squid (Calamari)",
      "Octopus",
      "Snail (Escargot)"
    ],
    triggers: [],
    commonFoods: ["Seafood boils", "Fried shrimp", "Sushi"],
    hiddenSources: ["Glucosamine supplements", "Fish stocks", "Fish sauces", "Pet food", "Fertilizers (crushed shells)"],
    crossContact: "Seafood kitchens with steam and shared tools.",
  },
  {
    id: "sesame",
    name: "Sesame",
    triggers: ["benne", "benniseed", "gingelly", "gomasio", "halvah", "sesamol", "sim sim", "tahini", "til", "tehina"],
    commonFoods: ["Hummus", "Tahini", "Sesame buns", "Falafel"],
    hiddenSources: [
      "Breadcrumbs",
      "\"Natural flavoring\"",
      "Cosmetics/soaps",
      "Sushi rolls"
    ],
    crossContact: "Bakeries and sesame oil on grills.",
  },
  {
    id: "mustard",
    name: "Mustard",
    triggers: ["brassica", "sinapis"],
    commonFoods: ["Mustard sauces", "Spreads", "Dressings"],
    hiddenSources: ["Deli meats", "Potato salad", "Pickles", "BBQ sauces", "Mayonnaise"],
    crossContact: "Condiment stations and shared prep areas.",
  },
  {
    id: "corn",
    name: "Corn",
    triggers: [
      "dextrose",
      "dextrin",
      "maltodextrin",
      "fructose",
      "corn syrup",
      "maize",
      "sorbitol",
      "xanthan gum",
      "zein",
      "polenta",
      "grits"
    ],
    commonFoods: ["Corn bread", "Tortillas", "Corn chips"],
    hiddenSources: [
      "Baking powder",
      "Confectioner's sugar",
      "Vanilla extract",
      "Citric acid",
      "Paper cups (wax coating)",
      "Envelope glue"
    ],
    crossContact: "Shared fryers and mills with corn flour.",
  },
];

export function findAllergenByTrigger(term) {
  if (!term) return null;
  const t = term.toLowerCase();
  return ALLERGENS.find((a) => a.triggers.some((tr) => tr.toLowerCase() === t));
}
